import type { DrawLevel } from '@ps/web-shared-api-types/v1-preview/SwPkrSpinAndGo';
import { DismissIcon, TickIcon, Translation } from '@ps/web-shared-components';
import React from 'react';

import { TXTCLI_Cash_Out_1 } from './CashOutRow.messages.json';
import styles from './CashOutRow.scss';

interface CashOutRowProps {
  transposedData: DrawLevel[];
}

const CashOutRow: React.FC<CashOutRowProps> = ({ transposedData }) => (
  <tr>
    <th>
      <Translation {...TXTCLI_Cash_Out_1} />
    </th>
    {transposedData.map((level, drawIndex) => (
      <td key={drawIndex}>
        {level.cashout ? (
          <TickIcon className={styles.tick} width={20} height={20} />
        ) : (
          <DismissIcon className={styles.close} width={16} height={16} />
        )}
      </td>
    ))}
  </tr>
);

export default CashOutRow;
